export default {
  "notifications": {
    "noNotifications": "لا توجد إشعارات حتى الآن",
    "markAsRead": "وضع علامة كمقروء",
    "markAllAsRead": "وضع علامة على الكل كمقروء",
    "delete": "حذف",
    "deleteConfirm": "هل أنت متأكد من رغبتك في حذف هذا الإشعار؟",
    "email": "بريد إلكتروني",
    "whatsapp": "واتس آب",
    "type": "النوع",
    "subject": "الموضوع",
    "body": "الرسالة",
    "recipient": "المستقبل",
    "status": "الحالة",
    "sent": "تم الإرسال",
    "failed": "فشل",
    "pending": "قيد الانتظار",
    "createdAt": "تم الإرسال في",
    "readAt": "تم القراءة في",
    "unreadCount": "الإشعارات غير المقروءة",
    "loadingMore": "جاري تحميل المزيد من الإشعارات...",
    "errorLoading": "خطأ في تحميل الإشعارات",
    "errorMarkingAsRead": "خطأ في وضع علامة على الإشعار كمقروء",
    "errorDeleting": "خطأ في حذف الإشعار",
    "successMarkingAsRead": "تم وضع علامة على الإشعار كمقروء",
    "successDeleting": "تم حذف الإشعار بنجاح"
  }
};

